import { type OverlayMode, useDevOverlay } from '../pixi/dev-overlay';
import styles from './dev-overlay.module.css';

const MODES: { value: OverlayMode; label: string }[] = [
  { value: 'none', label: 'Off' },
  { value: 'elevation', label: 'Elevation' },
  { value: 'biome', label: 'Biome' },
  { value: 'material', label: 'Material' },
  { value: 'room', label: 'Rooms' },
];

export function DevOverlayToggle(): JSX.Element {
  const mode = useDevOverlay((s) => s.mode);
  const setMode = useDevOverlay((s) => s.setMode);

  return (
    <div className={styles.toggle}>
      {MODES.map((m) => (
        <button
          key={m.value}
          className={mode === m.value ? styles.active : styles.button}
          onClick={() => setMode(m.value)}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
